import { EmptyState } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import CompanyData from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/CompanyData";

const CompanyDataWithErrorBoundary = () => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                dataAutomation="company-data"
                header={<CardHeader title={translate("si.company-analysis.company-data.card.header")} />}
                renderContent={() => (
                    <Box padding="24px">
                        <EmptyState
                            title={translate("si.company-analysis.company-data.card.empty.header")}
                            subtitle={translate("si.company-analysis.company-data.card.empty.text")}
                        />
                    </Box>
                )}
            />
        }
    >
        <CompanyData />
    </ErrorBoundaryWithLogging>
);

export default CompanyDataWithErrorBoundary;
